<template>
	<v-container
		grid-list-xl
		my-2
	>
		<v-layout
			row
			justify-center
			ma-0
		>
			<v-flex
				xs12
				md8
				pa-0
				ma-0
			>
				<slot name="alert"/>
			</v-flex>
		</v-layout>
		<v-layout
			row
			wrap
			justify-center
			ma-0
		>
			<v-flex xs12 md8>
				<v-card>
					<v-card-title class="info">
						<v-icon class="white--text pr-2">info</v-icon>
						<div class="headline white--text">Article Issues</div>
					</v-card-title>
					<v-card-text v-if="issueArticles.length > 0">
						<div
							v-for="(article, index) in issueArticles"
							:key="article.id"
						>
							<div class="article-issues pa-2">
								<div>
									<span class="body-2">{{ article.title }}</span>
									<div
										v-for="(error, index) in article.errorsList"
										:key="index"
										class="error--text"
									>
										{{ error }}
									</div>
								</div>
								<v-btn
									v-if="$userCan('manage_reports') && !report.isArchivedOrParentArchived"
									flat
									color="primary"
									@click="setEditArticle(article)"
								>
									Edit
								</v-btn>
							</div>
							<v-divider v-if="index !== issueArticles.length - 1"/>
						</div>
					</v-card-text>
					<v-card-text v-else>
						<div class="title text-xs-center">No Issues!</div>
					</v-card-text>
				</v-card>
			</v-flex>
			<!-- <v-flex v-if="duplicateItems.length > 0" xs12 md8>
				<v-card class="warning white--text">
					<v-card-text class="duplicate-articles">
						<div class="headline d-flex align-items-center">
							<v-icon class="white--text pr-2">warning</v-icon>
							Duplicate Article URL's: {{ duplicateItems.length | formatNumber }}
						</div>
						<v-btn
							v-if="$userCan('manage_reports') && !report.isArchivedOrParentArchived"
							flat
							dark
							@click="duplicateConfirm()"
						>
							Remove Duplicates
						</v-btn>
					</v-card-text>
				</v-card>
			</v-flex> -->
		</v-layout>
		<FullDialog
			:dialog="editArticle.show"
			dialog-title="Edit Article"
			@close-dialog="editArticle.show = false"
		>
			<template
				v-if="editArticle.show"
				slot="dialog-content"
			>
				<EditArticle
					:article="editArticle.article"
					single-edit
					@saving-done="editArticle.show = false"
					@close="editArticle.show = false"
				/>
			</template>
		</FullDialog>
		<Confirm ref="confirm"/>
	</v-container>
</template>

<script>
import FullDialog from '@/components/FullDialog';
import EditArticle from '@/components/Article/EditArticle';
import Confirm from '@/components/Confirm';

export default {
	components: {
		FullDialog,
		EditArticle,
		Confirm,
	},
	data() {
		return {
			editArticle: { show: false, article: null },
		};
	},
	computed: {
		report() {
			return this.$store.get('reports/currentReport');
		},
		articles() {
			return this.$store.get('articles');
		},
		issueArticles() {
			const articles = this.articles.filter(article => article.errorsSum > 0);
			return articles;
		},
		duplicateItems() {
			// @Christian Landgren https://stackoverflow.com/questions/840781/get-all-non-unique-values-i-e-duplicate-more-than-one-occurrence-in-an-array
			const articles = this.articles;

			const unique = articles.map(article => ({ count: 1, url: article.url }))
				.reduce((a, b) => {
					a[b.url] = (a[b.url] || 0) + b.count;
					return a;
				}, {});

			const duplicates = Object.keys(unique).filter(a => unique[a] > 1);
			return duplicates;
		},
	},
	methods: {
		setEditArticle(article) {
			this.editArticle.article = article;
			this.editArticle.show = true;
		},
		duplicateConfirm() {
			const reportName = this.$store.get('reports/currentReport').displayName;
			this.$refs.confirm.createConfirm(`This will delete all duplicate articles in ${reportName}.`, 'error')
				.then((answer) => {
					if (answer) {
						this.deleteDuplicates();
					}
				});
		},
		deleteDuplicates() {
			const articles = this.duplicateItems;
			const groupedDuplicates = [];
			let error = false;

			articles.forEach((article) => {
				const grouped = this.articles.filter(item => (item.url === article));
				groupedDuplicates.push(grouped);
			});

			groupedDuplicates.forEach((array) => {
				const remove = array.splice(1);
				remove.forEach((dup) => {
					dup.delete().then(() => {
						this.removeArticleFromStore(dup);
					}).catch(() => {
						error = true;
					});
				});
			});

			if (error) {
				this.$notify('error', 'Some duplicates failed to delete.');
			}
			else {
				this.$notify('success', 'Duplicates have been deleted.');
			}
		},
		removeArticleFromStore(article) {
			const articles = this.articles;
			const deleteIndex = articles.indexOf(article);
			articles.splice(deleteIndex, 1);
		},
	},
};
</script>

<style lang="scss" scoped>
.article-issues {
	display: flex;
	justify-content: space-between;
	align-items: center;
}
.duplicate-articles {
	display: flex;
	align-items: center;
	justify-content: space-between;
}
</style>
